import { SETTLEMENT_ORDER_COMMAND } from './enums';
import {
  ICreateSettlementOrder,
  ICreateSettlementOrderLabels,
  ICreateSettlementOrderToNewest,
} from './types';

export interface ISettlementOrderByLabelForm {
  labelId: string;
  startSettlementPeriodId: string;
  endSettlementPeriodId: string;
  planedSettlementDate: string;
  asap: boolean;
}

export interface ISettlementOrderLabelsForm {
  settlementPeriodId: string;
  planedSettlementDate: string;
  asap: boolean;
}

export interface ISettlementOrderToNewestForm {
  planedSettlementDate: string;
  asap: boolean;
  dividePeriods: boolean;
}

const toIsoDate = (date: string): string =>
  date.length ? new Date(date).toISOString() : new Date().toISOString();

export const mapCreateSettlementOrderBody = (
  values: ISettlementOrderByLabelForm
): ICreateSettlementOrder => ({
  labelId: values.labelId,
  startSettlementPeriodId: values.startSettlementPeriodId,
  endSettlementPeriodId: values.endSettlementPeriodId,
  asap: values.asap,
  fromClient: true,
  planedSettlementDate: toIsoDate(values.planedSettlementDate),
});

export const mapCreateSettlementOrderLabelsBody = (
  values: ISettlementOrderLabelsForm
): ICreateSettlementOrderLabels => ({
  command: SETTLEMENT_ORDER_COMMAND.labels,
  settlementPeriodId: values.settlementPeriodId,
  asap: values.asap,
  fromClient: true,
  planedSettlementDate: toIsoDate(values.planedSettlementDate),
});

export const mapCreateSettlementOrderToNewestBody = (
  labelId: string,
  values: ISettlementOrderToNewestForm
): ICreateSettlementOrderToNewest => ({
  labelId,
  asap: values.asap,
  dividePeriods: values.dividePeriods,
  fromClient: true,
  planedSettlementDate: toIsoDate(values.planedSettlementDate),
});
